import { Component, ChangeDetectionStrategy } from '@angular/core';
import {TokenService} from "../../_services/token.service";
import {MERCK_TENANT, MOBILE_WIDTH_VIEW} from "../../_helpers/Constants";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardComponent {
  currentDate = '';
  userName: string = '';
  maxLengthWidget = 40;
  isMobile = false;
  isWeatherLoading = true;
  isEventsLoading = true;
  isNiederschlagLoading = true;
  isAnnouncementsLoading = true;
  isNotificationsLoading = true;
  isMerckTenant = false;

  constructor( private tokenService: TokenService) {
    this.userName = this.tokenService.getUserName();
    this.isMerckTenant = this.tokenService.GetTenant() === MERCK_TENANT;
    this.getCurrentDate();
    this.isMobile = window.innerWidth <= MOBILE_WIDTH_VIEW;
  }

  get isDashboardLoading(): boolean {
    const rightWidgetLoading = this.isMerckTenant ? this.isNiederschlagLoading : this.isEventsLoading;
    const announcementsLoading = this.isMerckTenant ? false : this.isAnnouncementsLoading;
    return this.isNotificationsLoading || announcementsLoading || this.isWeatherLoading || rightWidgetLoading;
  }

  getCurrentDate(){
    const date = new Date();
    this.currentDate = date.toLocaleDateString('de-DE', {weekday: 'long', day:'2-digit', month:'long'});
  }
}
